module.exports = __webpack_public_path__ + "img/mt2.ce3db4c4.jpg";